'use strict'

angular.module('webremote.archive', [])

require('./controller')
require('./analyzer/controller')
